import React, { PropsWithChildren, useEffect } from 'react';

import { BackgroundContainer } from './Background.style';
import { BlockInfoType } from '../../common-types/BlockInfo.type';

export interface Props {
  backgroundImage: string | null | undefined;
  backgroundColor: string | null;
  dataTemplateConfig: string;
  addEditableBlock?: (block: BlockInfoType) => void;
  displayName: string;
  sizeInfo: {
    width: number;
    height: number;
  }
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  isEdition: boolean | undefined;
  className?: string;
  testId?: string;
}

export const Background: React.FunctionComponent<PropsWithChildren<Props>> = ({
  addEditableBlock,
  className,
  children,
  backgroundImage,
  backgroundColor,
  dataTemplateConfig,
  displayName,
  sizeInfo,
  onClick,
  isEdition,
  testId,
}: PropsWithChildren<Props>) => {
  const dataTemplateType = 'background';

  useEffect(
    () => {
      if (addEditableBlock) {
        addEditableBlock({
          blockType: dataTemplateType,
          configPath: dataTemplateConfig,
          label: displayName,
          sizeInfo,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataTemplateConfig]
  );

  return (
    <BackgroundContainer
      data-template-type={dataTemplateType}
      data-display-name={displayName}
      data-size-height={sizeInfo.height}
      data-size-width={sizeInfo.width}
      data-config-path={dataTemplateConfig}
      onClick={onClick}
      className={className}
      backgroundImage={backgroundImage}
      backgroundColor={backgroundColor}
      isEdition={isEdition}
      data-testid={testId}
    >
      {children}
    </BackgroundContainer>
  );
};
